import { useState } from 'react';
import { brandInfo } from '@/mocks/articles';

export default function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(null);

  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <section className="py-16 md:py-24 bg-background-100/60">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-foreground-950 mb-4">
            常见问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于蓝色小导航，你可能想了解的一切
          </p>
        </div>

        <div className="space-y-3">
          {brandInfo.faqs.map((faq, i) => (
            <div
              key={i}
              className="rounded-xl bg-background-50 border border-background-200/60 overflow-hidden"
            >
              <button
                onClick={() => toggle(i)}
                className="w-full flex items-center justify-between gap-4 px-5 md:px-6 py-4 md:py-5 text-left cursor-pointer"
              >
                <span className="text-sm md:text-base font-medium text-foreground-900 pr-4">
                  {faq.question}
                </span>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-all duration-300 flex-shrink-0 ${
                  openIndex === i ? 'bg-primary-100 text-primary-600 rotate-45' : 'bg-background-100 text-foreground-400'
                }`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === i ? 'max-h-[300px] opacity-100' : 'max-h-0 opacity-0'
                }`}
              >
                <div className="px-5 md:px-6 pb-4 md:pb-5 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}